import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import DonationsConfigModal from './DonationsConfigModal';
import DonationsConfigModalV3 from '../DonationsConfigModal.editor_donation';

export default withFeatureBranch({
  editor_donation: DonationsConfigModalV3,
})(DonationsConfigModal);
